var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.back}},[_vm._v("戻る")])
}
var staticRenderFns = []

export { render, staticRenderFns }